<template>
  <div class="applicant-filter" layout>
    <div class="mr-x1">
      <el-button class="el-button-mt" type="default" @click="onChangeBackEvent"
        ><i class="mdi mdi-arrow-left"></i>戻る</el-button
      >
    </div>
    <select-form
      :label="isFollowing.label"
      :icon="isFollowing.icon"
      :value="isFollowing.value"
      :options="isFollowing.options"
      :onChange="isFollowing.onChange"
      clearable
    ></select-form>
    <select-form
      :label="isCandidate.label"
      :icon="isCandidate.icon"
      :value="isCandidate.value"
      :options="isCandidate.options"
      :onChange="isCandidate.onChange"
      clearable
    ></select-form>
    <select-form
      :label="isWinner.label"
      :icon="isWinner.icon"
      :value="isWinner.value"
      :options="isWinner.options"
      :onChange="isWinner.onChange"
      clearable
    ></select-form>
    <select-form
      v-if="this.campaignType === 'old_web_instantwin'"
      :label="isWebInstantwinWinner.label"
      :icon="isWebInstantwinWinner.icon"
      :value="isWebInstantwinWinner.value"
      :options="isWebInstantwinWinner.options"
      :onChange="isWebInstantwinWinner.onChange"
      clearable
    ></select-form>
    <select-form
      :label="isResponder.label"
      :icon="isResponder.icon"
      :value="isResponder.value"
      :options="isResponder.options"
      :onChange="isResponder.onChange"
      clearable
    ></select-form>
    <div class="advance-filter-show" @click="toggleShowAdvanceFilter">
      <template v-if="!showAdvanceFilter">
        <span>詳細検索&nbsp;</span>
        <i class="mdi mdi-arrow-down-drop-circle-outline" />
      </template>
      <template v-else>
        <span>詳細検索を終了&nbsp;</span>
        <i class="mdi mdi-arrow-up-drop-circle-outline" />
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './applicant_filter';
</style>

<style lang="scss">
@use '@/client/assets/scss/variables.scss' as *;

.applicant-filter {
  .el-input__inner {
    height: $spacing-unit * 4;
  }

  .el-input {
    width: $spacing-unit * 18;
  }
}
</style>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import SelectForm from '@/client/components/_atoms/select_form'
import { TrackingService } from '@/client/services'
import { useTwitterApplicantStore } from '@/client/store/useTwitterApplicantStore'

export default defineComponent({
  components: {
    SelectForm
  },
  data() {
    return {
      // フォロー
      isFollowing: {
        value: '',
        label: 'フォロー',
        icon: 'check-circle',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: 'フォローあり',
            value: 1
          },
          {
            label: 'フォローなし',
            value: 0
          }
        ],
        onChange: (value: number) => {
          TrackingService.sendEvent('select:応募一覧（X）|フォロー')

          this.isFollowing.value = value
          if (this.params.isFollowing === value) {
            return
          }
          this.closeApplicantDrawer()
          this.setParams({ isFollowing: value })
          this.fetchApplicants()
        }
      },
      // 候補者
      isCandidate: {
        value: '',
        label: '候補者',
        icon: 'star',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '候補フラグあり',
            value: 1
          },
          {
            label: '候補フラグなし',
            value: 0
          }
        ],
        onChange: (value: number) => {
          TrackingService.sendEvent('select:応募一覧（X）|候補者')

          this.isCandidate.value = value
          if (this.params.isCandidate === value) {
            return
          }
          this.closeApplicantDrawer()
          this.setParams({ isCandidate: value })
          this.fetchApplicants()
        }
      },
      // 当選者
      isWinner: {
        value: '',
        label: '当選者',
        icon: 'trophy',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '当選フラグあり',
            value: 1
          },
          {
            label: '当選フラグなし',
            value: 0
          }
        ],
        onChange: (value: number | string) => {
          TrackingService.sendEvent('select:応募一覧（X）|当選者')

          this.isWinner.value = value
          if (this.params.isWinner === value) {
            return
          }
          this.closeApplicantDrawer()
          this.setParams({ isWinner: value })
          this.fetchApplicants()
        }
      },
      // Web当選者
      isWebInstantwinWinner: {
        value: '',
        label: 'Web当選者',
        icon: 'trophy',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: 'WEB抽選で当選',
            value: 1
          },
          {
            label: 'WEB抽選で落選',
            value: 0
          }
        ],
        onChange: (value: number | string) => {
          TrackingService.sendEvent('select:応募一覧（X）|Web当選者')

          this.isWebInstantwinWinner.value = value
          if (this.params.isWebInstantwinWinner === value) {
            return
          }
          this.closeApplicantDrawer()
          this.setParams({ isWebInstantwinWinner: value })
          this.fetchApplicants()
        }
      },
      // 回答者
      isResponder: {
        value: '',
        label: '回答者',
        icon: 'clipboard-check',
        options: [
          {
            label: '指定なし',
            value: ''
          },
          {
            label: '回答フラグあり',
            value: 1
          },
          {
            label: '回答フラグなし',
            value: 0
          }
        ],
        onChange: (value: number) => {
          TrackingService.sendEvent('select:応募一覧（X）|回答者')

          this.isResponder.value = value
          if (this.params.isResponder === value) {
            return
          }
          this.closeApplicantDrawer()
          this.setParams({ isResponder: value })
          this.fetchApplicants()
        }
      }
    }
  },
  computed: {
    ...mapState(useTwitterApplicantStore, {
      showAdvanceFilter: state => state.showAdvanceFilter,
      params: state => state.params,
      campaign: state => state.campaign ?? {},
      campaignType: state => state.campaign?.type
    })
  },
  methods: {
    ...mapActions(useTwitterApplicantStore, [
      'toggleShowAdvanceFilter',
      'setParams',
      'fetchApplicants',
      'closeApplicantDrawer'
    ]),

    onChangeBackEvent() {
      TrackingService.sendEvent('click:応募一覧（X）|戻る')

      this.$router.push('/twitter_campaigns/' + this.$route.params.campaignId + '/prizes')
    }
  }
})
</script>
